'use client'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css' //TODO: optionally include this?
import LiteYouTubeEmbed from 'react-lite-youtube-embed'

export default LiteYouTubeEmbed
